import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dca8344"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = { class: "update-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_SignalText = _resolveComponent("SignalText")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-others" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          (_ctx.$props.i18n.locale.value === 'en')
            ? (_openBlock(), _createBlock(_component_SignalText, {
                key: 0,
                signal: "caution"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_1')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_1')), 1),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_2')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_3')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_4')), 1),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_2')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_5')), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_3')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_5')), 1)
          ]),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_3')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_6')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_7')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_8')), 1),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_4')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_9')), 1),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_3_1')), 1),
              _createVNode(_component_router_link, { to: "/terms/privacy_policy" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('link_1')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_3_2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_5')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_10')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_11')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_12')), 1),
          _hoisted_1,
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$props.i18n.$text('update_date')), 1)
        ])
      ]),
      _: 1
    })
  ], 64))
}